import { ZIdName } from "src/types/ZIdName";
import { ZValueRestriction } from "src/types/ZRestriction";
import { ZUid } from "src/types/zUid";

export type AttrRestrictions = Record<ZUid, ZUid[]>; // primaryId => secondaryId[]

export const cvtRestrictionsFlatToDict = (
  pairs: ZValueRestriction[],
): AttrRestrictions => {
  const dict: AttrRestrictions = {};
  pairs.forEach(({ sourceId, restrictionId }) => {
    dict[restrictionId] = dict[restrictionId] ?? [];
    dict[restrictionId]?.push(sourceId);
  });
  return dict;
};

export const cvtRestrictionsDictToFlat = (
  dict: AttrRestrictions,
): ZValueRestriction[] => {
  const pairs: ZValueRestriction[] = [];
  Object.entries(dict).forEach(([key, row]) => {
    const restrictionId = key;
    row.forEach((sourceId) => {
      pairs.push({ restrictionId, sourceId });
    });
  });
  return pairs;
};

export const isRestrictionDictEmpty = (dict: AttrRestrictions): boolean => {
  const nonEmpty = Object.values(dict).find(({ length }) => length > 0);
  return !nonEmpty;
};

// Вариант создания таблицы ограницений, где все ячейки заполнены
export const createRestrictions = (
  masterDict: ZIdName[],
  slaveDict: ZIdName[],
): AttrRestrictions => {
  const result: AttrRestrictions = {};
  masterDict.forEach(({ id: masterId }) => {
    result[masterId] = slaveDict.map(({ id }) => id);
  });
  return result;
};
